export default {
  interface: {
    funding: {
      round: '라운드',
      funding_amount: '투자금액',
      valuation: '기업가치',
      lead_investor: '리드투자자',
    },
    image: '이미지',
    show_more: '더 보기',
    max_20_chars: '최대 20자',
    max_400_chars: '최대 400자',
    ai_inspiration_hub: 'AI 인스피레이션 허브',
    weekly_pick: '위클리 픽',
    loading_data: '데이터를 불러오는 중…',
    dateNav: {
      year: '년',
      month: '월',
      allTime: '전체 기간',
      jump: '연월',
      collapse: '접기',
      day: '일',
      selectDay: '일 선택',
      allDays: '전체 일',
      weekRange: '{sm} {sd}일 - {em} {ed}일',
      dayFormat: '{day}일',
    },
    months: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    share: {
      card_button: '공유',
      title: '공유 카드',
      sharer: '공유자',
      sharerPlaceholder: '이름 (선택사항)',
      message: '메시지',
      messagePlaceholder: '이 제품에 대한 생각 (선택사항)',
      generate: '카드 생성',
      generating: '생성 중...',
      cancel: '취소'
    },
    nav: {
      home: 'AI 제품',
      funding: 'AI 투자',
    },
    pageTitle: {
      home: 'AI 제품 - AI 인스피레이션 허브',
      tag: '{tag} 관련 제품 - AI 인스피레이션 허브',
    },
    title: {
      home: 'AI 인스피레이션 허브',
      funding: 'AI 투자 업데이트',
      search: '검색: "{query}"',
      tag: '{tag} 관련 제품',
      exportChannels: '글로벌 런칭 채널',
      tools: '실용 도구'
    },
    search: {
      placeholder: 'AI 제품 검색...',
      button: '검색',
      noResults: {
        title: '죄송합니다. 검색 결과가 없습니다',
        suggestion: '다른 키워드로 검색해 보세요'
      }
    },
    product: {
      visit_website: '{name} 웹사이트 방문',
      logo_alt: '{name} 로고',
      preview_image: '{name} 제품 미리보기 이미지 {index}/{total}',
      preview_image_full: '{name} 제품 미리보기 이미지 (전체 크기) {index}/{total}',
      view_more_tag: '{tag} 관련 제품 더 보기'
    }
  },
  channel: {
    scale: '규모'
  },
  meta: {
    description: 'AI 인스피레이션 허브는 최신의 종합적인 AI 제품과 도구를 제공하여 제품 영감과 워크플로우 도구를 찾을 수 있도록 도와드립니다',
    tagDescription: '{tag} 관련 AI 제품과 도구를 탐색하고 혁신적인 솔루션을 발견하세요',
    keywords: {
      home: 'AI 인스피레이션 허브, AI 도구, AI 제품, AI 애플리케이션, AI 리소스, 인공지능 도구, AI 개발, 창의적 도구, 워크플로우 최적화, 스타트업, 개인 개발',
      tag: '{tag}, AI 도구, AI 제품, 인공지능, 혁신적 도구, 지능형 애플리케이션'
    }
  }
}
